module.exports = __webpack_public_path__ + "static/media/arrow-back.5613e2f7.svg";